let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eQ2G5")).then(() => parcelRequire('c3Oit'));